module.exports = __webpack_public_path__ + "img/bg.949c6004.png";